import type { CollabEntity } from './entity.js'
import type { CoreElement, Entity, Persisted } from '@tunasong/schemas'

/** Ensure reservedPropertyMap has all the properties from Entity */
type EntityPropsEnum<T> = { [P in keyof Required<T>]: true }

export const reservedPropertyMap: EntityPropsEnum<Persisted<Entity> | CollabEntity | Pick<CoreElement, 'children'>> = {
  id: true,
  type: true,
  yDoc: true,
  children: true,
  starred: true,
  parentId: true,
  templateId: true,
  trash: true,
  tags: true,
  description: true,
  name: true,
  options: true,
  comments: true,
  sketches: true,
  userId: true,
  acls: true,
  metadata: true,
  createdAt: true,
  updatedAt: true,
  defaultView: true,
  pending: true,
  storage: true,
}
export const reservedProperties = Object.keys(reservedPropertyMap)
